export default __webpack_public_path__ + "static/media/DOM-MAY-2024.5d5c1010.png";